import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {
		list: [],
		current: null,
		activityStories: [],
		activityPosts: [],
	},
	mutations: {
		[MUTATIONS.DETAIL.BY_ID](state, detail) {
			state.current = detail
		},
		[MUTATIONS.DETAIL.LIST](state, list) {
			state.list = list
		},
		[MUTATIONS.DETAIL.ADD](state, detail) {
			const list = [...state.list].concat(detail)
			state.list = list
		},
		[MUTATIONS.DETAIL.DELETE](state, id) {
			let result = state.list.find(d => {
				return d.id === id
			})

			const idx = state.list.indexOf(result)
			if (idx > -1) {
				state.list.splice(idx, 1)
			}
		},
		[MUTATIONS.DETAIL.DISABLE](state, detail) {
			let result = state.list.find(d => {
				return d.id === detail.id
			})

			result.enabled = detail.enabled
			const idx = state.list.indexOf(result)
			if (idx > -1) {
				Vue.set(state.list, idx, result)
			}
		},
		[MUTATIONS.DETAIL.EVOLUTION_POST](state, { id, list }) {
			let result = state.list.find(d => {
				return d.id === id
			})

			result.evolution = list

			const idx = state.list.indexOf(result)
			if (idx > -1) {
				Vue.set(state.list, idx, result)
			}
		},
		[MUTATIONS.DETAIL.ACTIVITY](state, list) {
			state.activityPosts = list.map(l => {
				return {
					date: l.createdAt,
					count: l.countPosts,
				}
			})
			state.activityStories = list.map(l => {
				return {
					date: l.createdAt,
					count: l.countStories,
				}
			})
		},
	},

	actions: {
		[ACTIONS.DETAIL.ACTIVITY]({ commit, dispatch, state }, { id }) {
			commit(MUTATIONS.DETAIL.ACTIVITY, [])
			return API.DETAIL.ACTIVITY(id).then(res => {
				commit(MUTATIONS.DETAIL.ACTIVITY, res)
				return res
			})
		},

		[ACTIONS.DETAIL.BY_ID]({ commit, dispatch, state }, id) {
			return API.DETAIL.BY_ID(id).then(res => {
				commit(MUTATIONS.DETAIL.BY_ID, res)
				return res
			})
		},
		[ACTIONS.DETAIL.DISABLE]({ commit, dispatch, state }, { id, enabled }) {
			const detail = { id, enabled: !enabled }
			return API.DETAIL.UPDATE(detail).then(res => {
				commit(MUTATIONS.DETAIL.DISABLE, detail)
				return res
			})
		},

		[ACTIONS.DETAIL.LIST]({ commit, dispatch, state }, filter = {}) {
			return API.DETAIL.LIST(filter).then(res => {
				return res
			})
		},

		[ACTIONS.DETAIL.DELETE]({ commit, dispatch, state }, { id }) {
			return API.DETAIL.DELETE(id).then(res => {
				commit(MUTATIONS.DETAIL.DELETE, id)
				return res
			})
		},

		[ACTIONS.DETAIL.CREATE](
			{ commit, dispatch, rootState },
			{ id, name, network, enabled, account },
		) {
			return API.DETAIL.CREATE({
				profileId: id,
				profileName: name,
				// profilePicture: '',
				enabled: enabled,
				// color: '',
				networkId: network,
				accountId: +account,
				createdAt: new Date(),
			}).then(res => {
				commit(MUTATIONS.DETAIL.ADD, res)
				return res
			})
		},
	},

	getters: {
		getDetailList: state => state.list,
		getCurrentProfile: state => state.current,
		getDetailActivityPosts: state => state.activityPosts,
		getDetailActivityStories: state => state.activityStories,
	},
}
